import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.00221 3C5.00221 2.44687 5.44892 2 6.00184 2H13.9989C14.5518 2 14.9985 2.44687 14.9985 3C14.9985 3.55313 14.5518 4 13.9989 4H13.0773L13.4335 8.63125C14.5799 9.25312 15.4858 10.2937 15.9169 11.5906L15.9482 11.6844C16.0512 11.9906 15.9981 12.325 15.8107 12.5844C15.6233 12.8438 15.3203 13 14.9985 13H5.00221C4.68045 13 4.38056 12.8469 4.19001 12.5844C3.99945 12.3219 3.94947 11.9875 4.05256 11.6844L4.0838 11.5906C4.51489 10.2937 5.4208 9.25312 6.56725 8.63125L6.92337 4H6.00184C5.44892 4 5.00221 3.55313 5.00221 3ZM9.00073 14H11V17C11 17.5531 10.5533 18 10.0004 18C9.44744 18 9.00073 17.5531 9.00073 17V14Z",
		fill: "#0D2976"
	})
});
export default SvgPin;
